import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Main as MainLayout, } from '../../../../layouts';
import configBase from '../../../../configBase';
import axios from 'axios';
import {DropzoneDialog} from 'material-ui-dropzone';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardMedia from '@material-ui/core/CardMedia';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import Alert from '@material-ui/lab/Alert';
import CircularProgress from '@material-ui/core/CircularProgress';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';


class NovaCorretora extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      editBroker: false,
      objEditBroker: null,
      disabledFields: true,
      loadingFields: true,
      loadingSave: false,

      name: {value: '', required: true, error: '', type: 'text'},
      responsible: {value: '', required: true, error: '', type: 'text'},
      email: {value: '', required: true, error: '', type: 'email'},
      password: {value: '', required: true, error: '', type: 'password', show: false},
      image: {value: '', required: false, error: '', type: 'file', url: ''},

      dropzoneDialog: false,
      typeFile: '',

      errorRequest: false,
      msgErrorRequest: '',
      successRequest: false,
      msgSuccessRequest: '',
    };

  }

  componentDidMount() {
    let state = this.state;
    let search = this.props.history.location.search;

    // É uma edição
    if (search.length > 0) {
      let brokerId = this.props.history.location.search.replace('?brk=', '');

      if (brokerId && brokerId.length > 0 && search.indexOf('?brk=') > -1) {
        let url = `${configBase.api}Brokers/${brokerId}?filter={"include":"user"}&access_token=${localStorage.getItem('planos_t')}`;
        axios.get(url)
        .then((response) => {
          let state = this.state;
          state.objEditBroker = response.data;
          state.editBroker = true;
          state.name.value = response.data.user.name;
          state.email.value = response.data.user.email;
          state.password.required = false;
          state.responsible.value = response.data.responsible;

          if (response.data.user.image && response.data.user.image.length > 0)
            state.image.url = `${configBase.api}attachments/users/download/${response.data.user.image}`;

          state.disabledFields = false;
          state.loadingFields = false;
          this.setState(state);
        })
        .catch(function () {
          this.setError('Problema encontrado ao buscar dados da corretora');
        }.bind(this));
      }
      else {
        state.editBroker = false;
        state.disabledFields = true;
        state.loadingFields = false;
        this.setError('A corretora não foi identificada corretamente');
      }
    }
    // Não é uma edição
    else {
      state.editBroker = false;
      state.disabledFields = false;
      state.loadingFields = false;
    }

    this.setState(state);
  }

  updateFields(event) {
    let state = this.state;
    state[event.target.name].value = event.target.value;
    state[event.target.name].error = '';
    this.setState(state);
  }

  validateEmail(email) {
    let emailReg=/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

    if(!emailReg.test(email))
      return false;
    else
      return true;
  }

  testOnBlurEmail() {
    console.log(this.state.editBroker);
    // Para uma edição
    if (this.state.editBroker === true) {
      // Só verifica no banco se o email for diferente do já cadastrado
      if (this.state.email.value !== this.state.objEditBroker.user.email)
        this.onBlurEmail();
    }
    // Para uma nova
    else
      this.onBlurEmail();
  }

  onBlurEmail() {
    if (this.validateEmail(this.state.email.value) === true) {
      let url = `${configBase.api}Accounts/count?where={"email":"${this.state.email.value}"}&access_token=${localStorage.getItem('planos_t')}`;

      axios.get(url)
      .then((response) => {
        let state = this.state;
        // Se encontrar pelo menos um usuário ou mais com mesmo email
        if (response.data.count > 0)
          state.email.error = 'Já existe usuário com mesmo e-mail';
        else
          state.email.error = '';

        this.setState(state);
      })
      .catch(function () {
        let state = this.state;
        state.email.error = 'Problema encontrado ao validar email';
        this.setError('Problema encontrado ao validar email');
      }.bind(this));
    }
    else {
      let state = this.state;
      state.email.error = 'Formato de e-mail incorreto';
      this.setState(state);
    }
  }

  handleClickShowPassword() {
    let state = this.state;
    state.password.show = !state.password.show;
    this.setState(state);
  }

  dropzoneDialogOpen(typeFile=null) {
    if (this.state.disabledFields === false) {
      let state = this.state;
      state.dropzoneDialog = true;

      if (typeFile !== null)
        state.typeFile = typeFile;

      this.setState(state);
    }
  }

  dropzoneDialogClose() {
    let state = this.state;
    state.dropzoneDialog = false;
    this.setState(state);
  }

  fileToBase64(files) {
    let reader = new FileReader();
    let file = files[0];
    let ext = file.name.split('.').pop().toLowerCase();
    let state = this.state;

    state.image.value = ""
    state.image.error = '';

    if (ext === 'pdf')
      state.image.url = "pdf";
    else 
      state.image.url = window.URL.createObjectURL(file);

    this.dropzoneDialogClose();
    
    reader.onloadend = function() {
      let state = this.state;
      state.image.value = reader.result;
      this.setState(state);
    }.bind(this);

    reader.readAsDataURL(file);
  }

  checkField() {
    let fields = ['name', 'responsible', 'email', 'password', 'image'];
    let state = this.state;
    let error = false;

    state.loadingSave = true;
    this.setState(state);

    for (let i = 0; i < fields.length; i++) {
      if (state[fields[i]].error.length === 0) {
        if (state[fields[i]].required === true && state[fields[i]].value.length === 0) {
          error = true;
          state[fields[i]].error = 'Campo obrigatório';
        }
        else
          state[fields[i]].error = '';
      }
      else
        error = true;
    }

    this.setState(state);

    if (error === false) {
      if (this.state.editBroker === true)
        this.saveEditBroker();
      else
        this.saveBroker();
    }
    else {
      let state = this.state;
      state.loadingSave = false;
      this.setError('Preencher os campos de forma correta.');
    }
  }

  stateDefault() {
    let state = this.state;
    state.name.value = '';
    state.email.value = '';
    state.password.value = '';
    state.image.value = '';
    state.image.url = '';
    state.responsible.value = '';
    state.loadingSave = false;
    this.setState(state);
  }

  saveBroker() {
    if (this.state.name.error.length === 0 &&
      this.state.email.error.length === 0 &&
      this.state.password.error.length === 0 &&
      this.state.responsible.error.length === 0 &&
      this.state.image.error.length === 0) {
    
      let state = this.state;
      state.loadingSave = true;
      this.setState(state);

      let dataPost = {
        name: this.state.name.value,
        email: this.state.email.value,
        password: this.state.password.value,
        image: this.state.image.value,
        responsible: this.state.responsible.value
      };
      let url = configBase.api + 'Brokers/saveUserBroker?access_token='+localStorage.getItem('planos_t');
      
      axios.post(url, dataPost)
      .then(() => {
        this.stateDefault();
        this.setSuccess('Corretora salva com sucesso');
      })
      .catch(function () {
        let state = this.state;
        state.loadingSave = false;
        this.setError('Problema encontrado ao salvar corretora');
      }.bind(this));
    }
    else {
      let state = this.state;
      state.loadingSave = false;
      this.setError('Preencher os campos de forma correta.');
    }
  }

  saveEditBroker() {
    if (this.state.name.error.length === 0 &&
      this.state.email.error.length === 0 &&
      this.state.password.error.length === 0 &&
      this.state.responsible.error.length === 0 &&
      this.state.image.error.length === 0) {

      let state = this.state;
      state.loadingSave = true;
      this.setState(state);

      let dataPost = {
        responsible: this.state.responsible.value,
      };
      let dataPost2 = {
        name: this.state.name.value,
        email: this.state.email.value,
      };

      if (state.password.value.length > 0)
        dataPost2.password = state.password.value;

      let url = configBase.api + 'Brokers/upsertWithWhere?where={"id":"'+this.state.objEditBroker.id+'"}&access_token='+localStorage.getItem('planos_t');
      let url2 = configBase.api + 'Accounts/upsertWithWhere?where={"id":"'+this.state.objEditBroker.user.id+'"}&access_token='+localStorage.getItem('planos_t');

      axios.post(url, dataPost)
      .then(() => {
        axios.post(url2, dataPost2)
        .then(() => {
          // Quando editar a imagem
          if (this.state.image.value.length > 0) {
            let dataPost3 = {
              code: this.state.image.value,
              nameOld: '',
              userId: this.state.objEditBroker.user.id
            };
            let url3 = configBase.api + 'Attachments/saveImageUser?access_token='+localStorage.getItem('planos_t');

            if (this.state.objEditBroker.user.image && this.state.objEditBroker.user.image.length > 0)
              dataPost3.nameOld = this.state.objEditBroker.user.image;

            axios.post(url3, dataPost3)
            .then(() => {
              let state = this.state;
              state.loadingSave = false;
              this.setSuccess('Corretora salva com sucesso');
            })
            .catch(function () {
              let state = this.state;
              state.loadingSave = false;
              this.setError('Problema encontrado ao salvar imagem da corretora');
            }.bind(this));
          }
          // Não editou a imagem
          else {
            let state = this.state;
            state.loadingSave = false;
            this.setSuccess('Corretora salva com sucesso');
          }
        })
        .catch(function () {
          let state = this.state;
          state.loadingSave = false;
          this.setError('Problema encontrado ao salvar corretora');
        }.bind(this));
      })
      .catch(function () {
        let state = this.state;
        state.loadingSave = false;
        this.setError('Problema encontrado ao editar corretora');
      }.bind(this));
    }
    else {
      let state = this.state;
      state.loadingSave = false;
      this.setError('Preencher os campos de forma correta.');
    }
  }

  backListBroker() {
    this.props.history.push(`${process.env.PUBLIC_URL}/corretoras`);
  }

  setError(msg) {
    let state = this.state;
    state.errorRequest = true;
    state.msgErrorRequest = msg;
    this.setState(state);
  }

  errorClose() {
    let state = this.state;
    state.errorRequest = false;
    state.msgErrorRequest = '';
    this.setState(state);
  }

  setSuccess(msg) {
    let state = this.state;
    state.successRequest = true;
    state.msgSuccessRequest = msg;
    this.setState(state);
  }

  successClose() {
    let state = this.state;
    state.successRequest = false;
    state.msgSuccessRequest = '';
    this.setState(state);
  }


  render() {

    return (
      <MainLayout history={this.props.history}>
        <div id="corretoras" className={{flexGrow: 1}}>
          <Paper elevation={0} className="paper">
            <Grid container spacing={0}>
              <Grid item xs={12} sm={4} md={4} lg={4}>
                <Typography variant="button" gutterBottom style={{marginLeft: 6}}>
                  {
                    this.state.editBroker === true ? ('EDITAR CORRETORA') : ('CADASTRAR CORRETORA')
                  }
                </Typography>
              </Grid>

              <Grid item xs={12} sm={8} md={8} lg={8} className="botaoTituloAdd">
                <div className="botoesDeEnvio">
                  <Button
                    style={{backgroundColor: '#636d77', color: '#fff', marginRight: 5}}
                    variant="contained"
                    startIcon={<ArrowBackIcon />}
                    size="small"
                    onClick={this.backListBroker.bind(this)}
                    color="default"
                  >
                    VOLTAR
                  </Button>
                </div>
                <div className="botoesDeEnvio containerButton">
                  <Button
                    variant="contained"
                    style={{backgroundColor: configBase.corPrincipal, color: configBase.corSecundaria}}
                    startIcon={<SaveIcon />}
                    size="small"
                    onClick={this.checkField.bind(this)}
                    disabled={this.state.loadingSave}
                  >
                    SALVAR
                  </Button>
                  {
                    this.state.loadingSave === true ? (
                  <CircularProgress size={24} className="progressButton" />
                    ) : ('')
                  }
                </div>
              </Grid>
            </Grid>
          </Paper>

          <div id="novacorretoraConteudo" className="contentepanel" style={{marginTop: 40}}>
            <Paper className="paperForm">
              <div className="paper">
                <Typography variant="h6" gutterBottom className="titlePaperForm">
                  Informações da Corretora
                </Typography>
              </div>

              <div>
                <Divider />
              </div>

              <div className="paper">
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={6} lg={6} className="containerButton">
                    <TextField
                      fullWidth
                      error={this.state.name.error.length > 0 ? (true):(false)}
                      helperText={this.state.name.error}
                      label={this.state.name.required === true ? ("Corretora *"):("Corretora")}
                      type={this.state.name.type}
                      variant="outlined"
                      size="small"
                      name="name"
                      value={this.state.name.value}
                      onChange={this.updateFields.bind(this)}
                      disabled={this.state.disabledFields}
                    />
                    {
                      this.state.loadingFields === true ? (
                    <CircularProgress size={24} className="progressButton" />
                      ) : ('')
                    }
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} className="containerButton">
                    <TextField
                      fullWidth
                      error={this.state.responsible.error.length > 0 ? (true):(false)}
                      helperText={this.state.responsible.error}
                      label={this.state.responsible.required === true ? ("Responsável *"):("Responsável")}
                      type={this.state.responsible.type}
                      variant="outlined"
                      size="small"
                      name="responsible"
                      value={this.state.responsible.value}
                      onChange={this.updateFields.bind(this)}
                      disabled={this.state.disabledFields}
                    />
                    {
                      this.state.loadingFields === true ? (
                    <CircularProgress size={24} className="progressButton" />
                      ) : ('')
                    }
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4} className="containerButton">
                    <TextField
                      fullWidth
                      error={this.state.email.error.length > 0 ? (true):(false)}
                      helperText={this.state.email.error}
                      label={this.state.email.required === true ? ("E-mail *"):("E-mail")}
                      type={this.state.email.type}
                      variant="outlined"
                      size="small"
                      name="email"
                      value={this.state.email.value}
                      onChange={this.updateFields.bind(this)}
                      onBlur={this.testOnBlurEmail.bind(this)}
                      disabled={this.state.disabledFields}
                    />
                    {
                      this.state.loadingFields === true ? (
                    <CircularProgress size={24} className="progressButton" />
                      ) : ('')
                    }
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4} className="containerButton">
                    <FormControl
                      variant="outlined" size="small" fullWidth
                      disabled={this.state.disabledFields}
                    >
                      <InputLabel htmlFor="outlined-adornment-password">{this.state.password.required === true ? ("Senha *"):("Senha")}</InputLabel>
                      <OutlinedInput
                        id="outlined-adornment-password"
                        type={this.state.password.show === true ? ('text') : ('password')}
                        value={this.state.password.value}
                        name="password"
                        onChange={this.updateFields.bind(this)}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={this.handleClickShowPassword.bind(this)}
                              edge="end"
                            >
                              {this.state.password.show ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        }
                        labelWidth={70}
                      />
                    </FormControl>
                    {
                      this.state.loadingFields === true ? (
                    <CircularProgress size={24} className="progressButton" />
                      ) : ('')
                    }
                  </Grid>
                </Grid>

                <Grid container spacing={2} style={{marginTop: 10}}>
                  <Grid item xs={12} sm={6} md={6} lg={4}>
                    <Card>
                      <CardHeader
                        className="title_docs"
                        title="Imagem"
                      />

                      <Divider style={{marginBottom: 10}}/>

                      <CardActionArea
                        onClick={this.dropzoneDialogOpen.bind(this, 'rg')}
                        style={{cursor: this.state.disabledFields === true ? ('default') : ('pointer')}}
                      >
                        {
                          this.state.image.url.length > 0 ? (
                            this.state.image.url.substr(this.state.image.url.length - 3, this.state.image.url.length).toLowerCase() === 'pdf' ? (
                        <div style={{textAlign: 'center', paddingTop: 23, minHeight: 140}}>
                          <PictureAsPdfIcon fontSize="large" style={{fontSize: 100}}/>
                        </div>
                            ) : (
                        <CardMedia
                          component="img"
                          alt="Imagem"
                          height="140"
                          image={this.state.image.url}
                          title="Imagem"
                        />
                            )
                          ) : (
                            this.state.image.error.length > 0 ? (
                        <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                          <Alert severity="error" style={{width: '90%', margin: '0 auto'}}>
                            {this.state.image.error}
                          </Alert>
                        </div>
                            ) : (
                        <div style={{textAlign: 'center', paddingTop: 55, minHeight: 140}}>
                          <MuiAlert severity="info" variant="filled" elevation={0}
                            style={{width: '90%', margin: '0 auto', backgroundColor: '#67788a'}}
                          >
                            Nenhum arquivo anexado
                          </MuiAlert>
                        </div>
                            )
                          )
                        }

                        <Divider style={{marginTop: 10, marginBottom: 10}}/>
                      </CardActionArea>

                      {
                        this.state.image.url.length > 0 ? (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'rg')}
                        >
                          Editar
                        </Button>
                      </CardActions>
                          ) : (
                      <CardActions>
                        <Button
                          size="small" color="primary"
                          onClick={this.dropzoneDialogOpen.bind(this, 'rg')}
                          disabled={this.state.disabledFields}
                        >
                          SELECIONAR
                        </Button>
                      </CardActions>
                          )
                        }

                    </Card>
                  </Grid>
                </Grid>

                <DropzoneDialog
                  dialogTitle="Upload do arquivo"
                  cancelButtonText="CANCELAR"
                  submitButtonText="OK"
                  getFileAddedMessage={(fileName) => `Arquivo ${fileName} adicionado com sucesso.`}
                  open={this.state.dropzoneDialog}
                  onSave={this.fileToBase64.bind(this)}
                  acceptedFiles={['image/jpeg', 'image/png', 'image/jpg']}
                  showPreviews={true}
                  maxFileSize={5000000}
                  onClose={this.dropzoneDialogClose.bind(this)}
                  filesLimit={1}
                  dropzoneText="Clique ou arraste e solte um arquivo aqui"
                  previewText="Pré-visualização"
                  showAlerts={false}
                />
              </div>
            </Paper>
          </div>

          <Snackbar open={this.state.errorRequest} autoHideDuration={5000} onClose={this.errorClose.bind(this)}>
            <MuiAlert className="snackbarStyle" onClose={this.errorClose.bind(this)} severity="error" variant="filled" elevation={6}>
              {this.state.msgErrorRequest}
            </MuiAlert>
          </Snackbar>

          <Snackbar open={this.state.successRequest} autoHideDuration={1000} onClose={this.successClose.bind(this)}>
            <MuiAlert className="snackbarStyle" onClose={this.successClose.bind(this)} severity="success" variant="filled" elevation={6}>
              {this.state.msgSuccessRequest}
            </MuiAlert>
          </Snackbar>
        </div>
      </MainLayout>
    );

  }

}

NovaCorretora.propTypes = {
  history: PropTypes.object
};

export default withRouter(NovaCorretora);